import { ColDefField } from 'ag-grid-community';
import { VendorsTableDataType } from './types';

export const VENDORS_TABLE_FIELDS: Record<
  string,
  ColDefField<VendorsTableDataType, string | boolean | undefined>
> = {
  vendorNo: 'vendorNo',
  vendorName: 'vendorName',
  paymentMethod: 'paymentMethod',
  invoiceId: 'invoiceId',
  amount: 'amount',
  discountAmount: 'discountAmount',
  netAmount: 'netAmount',
  invoiceDate: 'invoiceDate',
  dueDate: 'dueDate',
  onHold: 'onHold'
};

export const DEFAULT_COL_WIDTH = 150;
export const MIN_COL_WIDTH = 50;

export const FLOAT_REGEX = /-|\d|\./g;

export const HEADER_CHECKBOX_CELL_SELECTOR =
  '.ag-header-cell[col-id="ag-Grid-AutoColumn"] > .ag-react-container';

export const INVOICE_STATES = [
  'POSTED',
  'APPROVED',
  'AUTHORIZED',
  'PAYING'
] as const;
